import * as actionTypes from '../../constants/ActionTypes/Dashboard';

const initialState = {
    swapDevice: {},
    loading: false,
    error: "",
    success:false,
}

const SwapDevice = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SWAP_DEVICE:
            return {
                ...state,
                loading: true,
                error:""
            }
        case actionTypes.SWAP_DEVICE_SUCCESS:
            return {
                ...state,
                swapDevice: action.swapDevice,
                loading: false,
                success:true,
                error:""
            }
        case actionTypes.SWAP_DEVICE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message
            }
        case actionTypes.RESET_SWAP:
            return {
                ...state,
                error:""
            }
        default:
            return {...state};
    }
}

export default SwapDevice;